import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Apple Valley",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/minnesota",
  heroImageQuery:
    "Aerial view of Apple Valley Minnesota suburban cityscape with the Minnesota Zoo, modern residential neighborhoods, parks and green spaces, south metro landscape, community center and sports facilities, warm golden hour lighting, professional photography, no readable text or signs",
  heroImageSeq: "apple-valley-mn-hero",
  heroDescription:
    "Family cruise to the Caribbean in three weeks? School trip to Europe and your teenager's passport expired? Business meeting in Asia with short notice? We help Apple Valley residents — from Minnesota Zoo families to south metro business owners and Dakota County commuters — get their passports fast. As a registered U.S. Department of State courier — not a reseller — we offer a best price guarantee and rates typically 30–100% lower than FedEx, Staples, and other third-party passport courier resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  geoPosition: "44.7319; -93.2177",
  geoPlacename: "Apple Valley, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/apple-valley/",
  localAreaTitle: "Serving Apple Valley & South Metro Dakota County",
  localAreaText: [
    "Apple Valley, Minnesota is a thriving suburban community of roughly 55,000 residents located in the southern reaches of the Twin Cities metro area. The city is best known as the home of the Minnesota Zoo, one of the state's premier attractions, which draws families from across the region and creates a community with a strong orientation toward travel, exploration, and education. Apple Valley's residents are largely families with children, young professionals, and established suburbanites who value community, schools, and quality of life.",
    "The family-oriented character of Apple Valley creates distinct travel patterns. Spring break trips, summer European tours, and holiday cruises are common. The city's excellent schools and active youth programs mean many families travel for sports tournaments, academic competitions, and cultural exchanges. When a child's passport expires or a teenager needs their first document, parents discover the need with only weeks before departure — and standard government processing is too slow.",
    "Apple Valley's location in Dakota County, about 20 miles south of Minneapolis via I-35W, provides easy access to MSP Airport while maintaining a more affordable suburban lifestyle than closer-in communities. The city also serves as a hub for surrounding Dakota County communities — Lakeville, Rosemount, Farmington, and Eagan residents all pass through or near Apple Valley for services and shopping. This regional role makes Apple Valley a natural service center for south metro passport needs.",
  ],
  nearbyCities: [
    { name: "Apple Valley", zips: "55124" },
    { name: "Lakeville", zips: "55044" },
    { name: "Rosemount", zips: "55068" },
    { name: "Farmington", zips: "55024" },
    { name: "Eagan", zips: "55121, 55122, 55123" },
    { name: "Burnsville", zips: "55306, 55337" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required to begin. Complete your order from your home in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Use overnight shipping to send your documents directly to us — we handle every detail from there.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "Apple Valley & South Metro Coverage",
  serviceAreaDescription: "Serving Dakota County and south metro communities with overnight courier pickup",
  faqs: [
    {
      q: "How fast can I get a passport in Apple Valley, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a post office in Apple Valley can take 2–6 months. For families and business travelers with international plans, that timeline is not viable.",
    },
    {
      q: "Can families from Apple Valley get child passports quickly?",
      a: "Yes — families are one of our most common client types in Apple Valley. Spring break trips, summer vacations, and school travel often require child passports on compressed timelines. We regularly process expedited child passports for families — as fast as 2–9 business days.",
    },
    {
      q: "What if my passport expires before a family cruise?",
      a: "Many Apple Valley families book cruises and discover passport issues close to departure. Most cruise lines require valid passports for all passengers. If your passport is close to expiring, we recommend expedited processing. Standard mail-in renewal typically takes 2–6 months.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center?",
      a: "No — most Apple Valley travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Apple Valley. Start your order online, follow the checklist, and ship your documents overnight from anywhere in south metro.",
    },
    {
      q: "What documents do I need for an expedited passport?",
      a: "Most applicants need: proof of U.S. citizenship, a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required.",
    },
    {
      q: "Is Fast Passport Center an official government agency?",
      a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing.",
    },
  ],
  testimonials: [
    {
      name: "The Johnson Family",
      location: "Apple Valley, MN",
      rating: 5,
      text: "We booked a Caribbean cruise for our family of five with three weeks notice. Our daughter's passport had expired. Fast Passport Center processed her child passport in six business days. We made our cruise and had an amazing vacation. Their guidance through the parental consent process was excellent.",
      service: "Child Passport",
    },
    {
      name: "Mark T.",
      location: "Apple Valley, MN",
      rating: 5,
      text: "I had a business trip to Toronto with two weeks notice. My passport was expired. Fast Passport Center processed my renewal in four business days. I made my meeting and secured a new contract. Very professional service.",
      service: "Passport Renewal",
    },
    {
      name: "The Garcia Family",
      location: "Rosemount Area, Apple Valley",
      rating: 5,
      text: "Our son's school announced a trip to Germany with four weeks notice. His passport was expired. Fast Passport Center handled the expedited process in five business days. He made the trip and had a life-changing experience. We are so grateful.",
      service: "Emergency Passport",
    },
  ],
  nearbyLinks: [
    { name: "Minneapolis", href: "/minneapolis" },
    { name: "St. Paul", href: "/st-paul" },
    { name: "Eagan", href: "/eagan" },
    { name: "Lakeville", href: "/lakeville" },
    { name: "Burnsville", href: "/burnsville" },
    { name: "Rosemount", href: "/minnesota" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Apple Valley",
  introDescription: "Fast, reliable passport processing for Apple Valley and south metro Dakota County travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local Apple Valley and south metro resources to help you gather everything you need before your next international trip.",
  acceptanceFacilities: [
    {
      name: "Apple Valley Post Office",
      address: "14321 Grand Ave, Apple Valley, MN 55124",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(952) 431-0034",
      notes: "Passport acceptance services available by appointment. Photo services on-site. Primary facility for Apple Valley and Dakota County.",
    },
    {
      name: "Lakeville Post Office",
      address: "21090 Holyoke Ave, Lakeville, MN 55044",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(952) 469-2514",
      notes: "Convenient for Lakeville and southern Dakota County residents. Passport photos available. Call ahead for appointment availability.",
    },
    {
      name: "Burnsville Post Office",
      address: "200 W Travelers Trl, Burnsville, MN 55337",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(952) 890-1453",
      notes: "Serves Burnsville and west Dakota County residents. Larger facility with more appointment slots.",
    },
    {
      name: "Eagan Post Office",
      address: "3145 Lexington Ave S, Eagan, MN 55121",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(651) 454-5834",
      notes: "Primary acceptance facility for Eagan and northern Dakota County residents.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Apple Valley", address: "15025 Glazier Ave, Apple Valley, MN 55124", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — Apple Valley", address: "15280 Galaxie Ave, Apple Valley, MN 55124", hours: "Call for hours" },
    { name: "The UPS Store — Apple Valley", address: "14755 Victor Rd, Apple Valley, MN 55124", hours: "Call for hours" },
    { name: "Walgreens — Lakeville", address: "17668 Dodd Blvd, Lakeville, MN 55044", hours: "Call for hours" },
    { name: "CVS Pharmacy — Burnsville", address: "300 W Travelers Trl, Burnsville, MN 55337", hours: "Daily 7 AM – 10 PM" },
    { name: "Walmart — Apple Valley", address: "15000 Glacier Ave, Apple Valley, MN 55124", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Minnesota Driver and Vehicle Services — Dakota County",
      address: "Dakota County area offices",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, titles & registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "Dakota County Service Center — Apple Valley",
      address: "Apple Valley, MN 55124",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Dakota County option. Online scheduling available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 18 miles from Apple Valley — 22 minutes by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Primary commercial airport for the Twin Cities. Nonstop service to major international hubs including Amsterdam, London, Paris, Tokyo, and Reykjavik.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: true,
    },
    {
      code: "RST",
      name: "Rochester International Airport",
      distance: "Rochester, MN — about 75 miles south",
      address: "7600 Helgerson Dr SW, Rochester, MN 55902",
      note: "Secondary option for southern Minnesota travelers. Seasonal international charters and domestic connections.",
      flightUrl: "https://www.flyrst.com/",
      flightLabel: "Rochester Airport",
      featured: false,
    },
  ],
  travelCards: [
    {
      title: "MSP — Minneapolis-Saint Paul International Airport",
      subtitle: "Primary gateway for Apple Valley international travelers",
      content:
        "MSP is the primary departure point for Apple Valley's international travelers. Located about 18 miles north via I-35W, it offers nonstop service to Amsterdam, London, Paris, Tokyo, and Reykjavik. The airport's accessibility from south metro makes it convenient for both family and business travel.",
      tip: "Check your passport expiration before booking MSP international connections. Most countries require six months validity beyond your return date.",
      icon: "ri-flight-takeoff-line",
    },
    {
      title: "Family & School Vacation Travel",
      subtitle: "Spring break, summer tours, and holiday cruises",
      content:
        "Apple Valley families are frequent travelers. Spring break trips to Mexico, summer European tours, and Caribbean cruises are common. The city's excellent schools and active youth programs also generate travel for sports tournaments, academic competitions, and cultural exchanges.",
      tip: "Check every family member's passport at the start of the school year. Children's passports expire in 5 years, not 10. Plan renewals 6 months before any planned travel.",
      icon: "ri-ship-line",
    },
    {
      title: "Minnesota Zoo & Educational Travel",
      subtitle: "School programs, youth groups, and family learning trips",
      content:
        "Apple Valley is home to the Minnesota Zoo, which creates a community oriented toward education and exploration. Many families extend this educational focus to international travel: wildlife safaris, marine biology trips, and cultural immersion programs for students.",
      tip: "Educational travel often has fixed departure dates. Check passports when you register for programs, not when you receive the final itinerary.",
      icon: "ri-graduation-cap-line",
    },
    {
      title: "Dakota County Business & Commuter Travel",
      subtitle: "South metro professionals with international clients",
      content:
        "Apple Valley and Dakota County include many professionals who commute to Minneapolis, St. Paul, and the south metro business corridor. These professionals often have international clients, conferences, and supplier visits that require travel on short notice.",
      tip: "Business travelers should check passport expiration at the start of each quarter. Set calendar reminders for the entire team.",
      icon: "ri-briefcase-4-line",
    },
  ],
  destinations: [
    {
      name: "Mexico & Caribbean",
      context: "Family cruises, Cancun resorts, and spring break trips from MSP",
      urgency: "Cruise and resort bookings often happen 2–4 weeks before departure",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "United Kingdom",
      context: "London business, Edinburgh heritage, and European connections",
      urgency: "Business travel frequently has 10–21 day lead time",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "School exchange programs, business conferences, and heritage travel",
      urgency: "School trip schedules and conference dates are fixed",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Italy",
      context: "Mediterranean cruises, Rome heritage, and cultural tours",
      urgency: "Cruise departures and tour schedules are fixed",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Canada",
      context: "Toronto business, Ontario fishing, and northern cabin visits",
      urgency: "Summer travel and hunting trips peak May through September",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "France",
      context: "School language programs, Paris vacations, and cultural exchanges",
      urgency: "School programs and exchange dates are fixed",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    {
      stat: "55%",
      label: "of Apple Valley expedited requests are family or school travel discovered within 4 weeks of departure",
    },
    {
      stat: "3–5 Weeks",
      label: "average notice Apple Valley families have before a planned international trip",
    },
    {
      stat: "Mar–Aug",
      label: "peak season when spring break, summer vacations, and school trips coincide",
    },
    {
      stat: "72 Hours",
      label: "shortest emergency turnaround we have accommodated for an Apple Valley family",
    },
  ],
};

export default function AppleValleyPage() {
  return <CityPage data={data} />;
}